import React, { FC } from 'react';

import { useChannelProgramShowed } from '../../analytics/hooks/use-channel-program-showed';
import { useChannelProgramClosed } from '../../analytics/hooks/use-channel-program-closed';
import { useChannelProgramNavigated } from '../../analytics/hooks/use-channel-program-navigated';

import { ChannelProgramModalContainer, ChannelProgramModalContainerProps } from './container';

export const ChannelProgramModalWithAnalytics: FC<
    ChannelProgramModalContainerProps & {
        vsid: string | undefined;
        psid: string | undefined;
    }
> = ({ vsid, psid, ...rest }) => {
    const { contentId: channelId } = rest;

    const handleShowed = useChannelProgramShowed({
        channelId,
    });

    const handleClose = useChannelProgramClosed({
        channelId,
    });

    const handleNavigated = useChannelProgramNavigated({
        channelId,
        vsid,
        psid,
    });

    return (
        <ChannelProgramModalContainer
            {...rest}
            onShow={handleShowed}
            onClose={handleClose}
            onTrackNavigated={handleNavigated}
        />
    );
};
